<template>
    <div><p>© Federico Moretti 2015-{{ year }}</p></div>
</template>

<script>
export default {
  computed: {
    year() {
      const date = new Date();
      return date.getFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
  div {
    font-family: $font-family;
    text-align: center;
    color: $light-font-color;
  }

  p {
    margin: 0 0 5px;
  }
</style>
